import { PhotoDisplayHandler } from "components";
import { truncateString } from "utils/helpers/strings";
import { formatDate } from "utils/helpers/dateTime";
import { useNavigate } from "react-router-dom";
import "./BlogItem.scss";

type BlogItemProps = {
  post: any;
  pathname: string;
};
const BlogItem = ({ post, pathname }: BlogItemProps) => {
  const navigate = useNavigate();
  return (
    <div className="Blog-Item" key={post.slug}>
      <div
        className="Blog-Box-Item"
        onClick={() => navigate(`${pathname}/${post.slug}`)}
      >
        <div className="Blog-Item-Image-Box">
          <PhotoDisplayHandler
            img_name={post.background_image}
            calculate={false}
            img_class_name="Blog-Item-Image"
            img_alt={post.post_title}
            width="96%"
            height="auto"
          />
        </div>
        <div className="Blog-Item-Info-Box">
          <h5 className="Blog-Item-Info-Title">{post.post_title}</h5>
          {pathname === "/partners" || pathname === "/solar-panels" ? (
            <>
              <p className="Blog-Item-Info-Text">
                {truncateString(post.post_description, 100)}
              </p>
            </>
          ) : (
            <></>
          )}
          <p className="Blog-Item-Info-Date">{formatDate(post.created_at)}</p>
        </div>
      </div>
    </div>
  );
};
export default BlogItem;
